<template>
	<az-form>
		<v-data-iterator
			:items="items"
			hide-default-footer
			disable-pagination
			class="az-form-content data-iterator table-fill-height"
		>
			<template #default="props">
				<v-row>
					<v-col v-for="item in props.items" :key="item.id" cols="12" class="pb-1">
						<v-card outlined @click="tratarEventoVisualizar(item)" class="pt-2 pb-2 box-shadow-vcard">
							<v-row>
								<v-col cols="12" sm="12" md="5" lg="5">
									<v-list-item two-line>
										<v-list-item-content>
											<v-list-item-title
												class="grey--text text--darken-2 font-weight-bold label mb-3"
											>
												{{ item.nome }}
											</v-list-item-title>
											<v-list-item-subtitle class="grey--text text--darken-1"
												>Publicado em
												{{
													item.ultimaAtualizacao
														| azDate(formatosDefault.DATA_HORA_MINUTO_ESCAPED)
												}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
			</template>
			<template #no-data>
				<template-listagem-vazia
					class="align-content-center v-data-table__empty-wrapper"
					:total-itens="items.length"
					:textos="textosTemplateListagemVazia"
				>
				</template-listagem-vazia>
			</template>
		</v-data-iterator>
	</az-form>
</template>

<script>
import { formatosDefault } from '@/core/constants'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'

export default {
	name: 'relatorio-painel-listagem-tabela',
	components: { TemplateListagemVazia },
	props: {
		items: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			formatosDefault,
			textosTemplateListagemVazia: {
				titulo: 'Nenhum relatório disponível',
			},
		}
	},
	methods: {
		tratarEventoVisualizar(item) {
			this.$emit('acessar-relatorio', item)
		},
	},
}
</script>
<style scoped lang="stylus">
.box-shadow-vcard
	box-shadow 0 2px 4px #0000001a

.box-shadow-vcard:hover
	box-shadow 0 4px 8px #0000001a

.az-form-content
	padding 0
	margin-top 0

	.v-input__icon--clear .v-icon.v-icon
		font-size 18px !important

	&.row--dense
		margin 0 !important

	.v-select__selections
		font-size 13px
		color #888 !important

.v-data-table__empty-wrapper
	height 60vh

@media (max-width: 720px)
	.v-data-table__empty-wrapper
		text-align center
		display flex
		justify-content center
		align-items center
</style>
